export default __webpack_public_path__ + "v3.422/facebook-logo.png";